<template>
	<div class="sales">
		<HNB single-title="全网销量TOP5产品"></HNB>
		<div style="width: 100%;position: relative;">
			<div class="sales-banner" v-for="item in centertotal" v-show="bottomactive==item.active">
				<img :src="item.banner" />
				<div style="width:65.125rem;height: 100%; position: absolute;left:0;top:0;right:0;bottom:0; margin:auto; ">
					<SvgIcon :svg-name="item.svgName" size="100" style="position: absolute;left:0;top: 25%;z-index: 98;"></SvgIcon>
				</div>
				<div class="bannershell">
				</div>
				<div class="bannerinfo" v-for="item in bannertotal" v-show="bottomactive==item.active">
					<div class="infobox1">{{item.title}}</div>
					<div class="infobox2">{{item.info}}</div>
					<div class="infobox3" @click="openherf(item.active)">进一步了解></div>
				</div>
			</div>
		</div>
		<div class="sales-center" v-for="item in centertotal" v-show="bottomactive==item.active">
			<div class="left" style="position: relative;">
				<SvgIcon :svg-name="item.svgName" size="80" style="position: absolute;right: 5%;top: 12%;z-index: 98;"></SvgIcon>
				<div class="left-box1 animated fadeIn" v-for="(e,i) in item.write" v-show="num == i">{{e.title}}</div>
				<div class="left-box2 animated fadeIn" v-for="(e,i) in item.write" v-show="num == i">{{e.letter}}</div>
				<div style="display: flex; padding-left: 18%;padding-top: 5%;">
					<div class="left-box3" v-for="(e,i) in 3" :class="{'active':num==i}">
					</div>
				</div>
			</div>
			<div class="right " v-for="item in centertotal" v-show="bottomactive==item.active">
				<img class="animated fadeIn " v-for="(e,i) in item.imgurl" :src="e.img" v-show="num == i" />
			</div>

		</div>

		<div class="sales-bottom">
			<div class="sales-shell" v-for="(item,i) in bottomtotal" :class="{'active':item.active==bottomactive}" @click="choose(item.active)">
				<div class="sales-shell-top">{{item.top}}</div>
				<div class="sales-shell-img">
					<SvgIcon :svg-name="item.svgName" size="40" style="position: absolute;right: -65%;top: -30%;z-index: 98;"></SvgIcon>
					<img :src="item.image" />
				</div>
				<div class="sales-bottom-title">{{item.info1}}</div>
				<div class="sales-bottom-write">{{item.info2}}</div>
			</div>
		</div>
		
		<p class="geo-last-updated">本文最后更新于：{{ '' | yearMonth }}</p>

		<bottom :BsTitle="bsTitle"></bottom>
	</div>
</template>

<script>
	import HNB from '../components/HeaderNavigationBar.vue'
	import bottom from '../components/bottomShow.vue'
	import SvgIcon from '../components/SvgIcon.vue'
	export default {
		name: 'sales',
		data() {
			return {
				flag: true,
				bottomactive: 'xiaoshafa',
				num: '0',
				bsTitle: ['销量领先产品'],
				bannertotal: [
					{
						title: '护腰阅读小沙发',
						info: '人体工学设计丨撑肘立腰裹臀丨单手可拎丨EPS一体成型',
						active: 'xiaoshafa'
					},
					{
						title: '蝶形人体工学腰靠',
						info: '仿生蝶形设计丨自适应追背承托丨双扭簧专利丨适配身高调节',
						active: 'beikao'
					},
					{
						title: '鹅卵石坐垫',
						info: '户外一拎即走｜磁吸折叠便携｜人体工学减压丨久坐回弹舒适',
						active: 'zhediezuodian'
					},
					{
						title: '冥想坐垫',
						info: '缓解身心压力丨快速专注冥想丨引导正确坐姿丨耐脏抗菌面料',
						active: 'zuodian1'
					},										
					{
						title: '随身魔力按摩贴',
						info: '随身按摩|手法多样|一指操控|小巧便捷',
						active: 'molitie'
					}
				],
				bottomtotal: [
				{
						top: 'TOP 1',
						svgName:'',
						image: this.GLOBAL.imgHost + '/images/sales/bottom11.png',
						info1: '护腰阅读小沙发',
						info2: '为你撑腰 舒适久坐',
						
						active: 'xiaoshafa'
					},
					{

						top: 'TOP 2',
						svgName:'IF',
						image: this.GLOBAL.imgHost + '/images/sales/bottom22.png',
						info1: '蝶形人体工学腰靠',
						info2: '科学塑形 舒适依靠',
						active: 'beikao'
					},
					{

						top: 'TOP 3',
						svgName:'',
						image: this.GLOBAL.imgHost + '/images/sales/bottom33.png',
						info1: '鹅卵石坐垫',
						info2: '随时随地 冥想自由',
						active: 'zhediezuodian'

					},
					{

						top: 'TOP 4',
						svgName:'',
						image: this.GLOBAL.imgHost + '/images/sales/bottom44.png',
						info1: '冥想坐垫',
						info2: '一坐入静 专注冥想',
						active: 'zuodian1'

					},
					{

						top: 'TOP 5',
						svgName:'IF',
						image: this.GLOBAL.imgHost + '/images/sales/bottom1.png',
						info1: '随身魔力按摩贴',
						info2: '口袋里的魔术师',
						active: 'molitie'
					}
				],
				centertotal: [
				{
						banner: this.GLOBAL.imgHost + '/images/sales/banner1.jpg',
						svgName:'',
						imgurl: [{
								img: this.GLOBAL.imgHost + '/images/sales/anmotie1.jpg'
							},
							{
								img: this.GLOBAL.imgHost + '/images/sales/anmotie2.jpg'
							},
							{
								img: this.GLOBAL.imgHost + '/images/sales/anmotie3.jpg'
							},
						],
						write: [{
								title: '随心随行 想按就按',
								letter: '放进口袋，随身携带，生活中、旅途中、运动中，只要你想，随时拿出它，给自己疲惫的身体一点完全偷懒的自由！'
							},
							{
								title: '传统与科技的领先结合 有助于缓解肌肉不适和疲劳',
								letter: '采用TENS低频脉冲按摩技术，有助于缓解肌肉疼痛与疲劳。大师级按摩手法，畅通经络、舒缓神经快速恢复机体活力。'
							},
							{
								title: '各部位通用 哪里酸痛贴哪里',
								letter: '随心移位，肩部、背部、腰部、四肢等部位都适用。'
							},
						],
						active: 'molitie',
					},
					{
						banner: this.GLOBAL.imgHost + '/images/sales/banner11.jpg',
						svgName:'',
						imgurl: [{
								img: this.GLOBAL.imgHost + '/images/sales/xiaoshafa1.jpg'
							},
							{
								img: this.GLOBAL.imgHost + '/images/sales/xiaoshafa2.jpg'
							},
							{
								img: this.GLOBAL.imgHost + '/images/sales/xiaoshafa3.jpg'
							},
						],
						write: [{
								title: '人体工学设计，科学贴合人体曲线',
								letter: '腰臀呈80°夹角，实现肘/腰/臀三维立体支撑，手臂托举、腰背承托、臀部包裹、双腿倚靠，入座就是好坐姿'
							},
							{
								title: '占地小 重量轻 单手可拎',
								letter: '小巧轻便不占地方，相当于宠物猫的重量，小孩、女生单手拎起，阳台、客厅卧室等随心移动'
							},
							{
								title: 'EPS龙骨一体成型结构',
								letter: '与儿童安全座椅/安全头盔同款材料，三层高密度回弹海绵填充，抗压耐用，久坐不塌陷'
							},
						],
						active: 'xiaoshafa',

					},
					{
						banner: this.GLOBAL.imgHost + '/images/sales/banner22.jpg',
						svgName:'',
						imgurl: [{
								img: this.GLOBAL.imgHost + '/images/sales/beikao11.jpg'
							},
							{
								img: this.GLOBAL.imgHost + '/images/sales/beikao22.jpg'
							},
							{
								img: this.GLOBAL.imgHost + '/images/sales/beikao33.jpg'
							},
						],
						write: [{
								title: '卡扣式创新一键升降、适配不同身高体型',
								letter: '舒适随心选择，内置升降式机械结构 。85mm的升降范围，完美贴合大部分人的身型'
							},
							{
								title: '双扭簧设计专利、动态缓冲和追背支撑、分散体压',
								letter: '采用双直径扭簧支撑结构：下端为直径3.0mm扭簧，能够稳定支撑来自腰部的压力，上端为直径2.8mm扭簧，灵活承托来自背部及肩膀后倾的压力'
							},
							{
								title: '蝶形背靠支撑面更大，增大30%支撑面',
								letter: 'E升级蝶形设计，增大30%支撑面，提升支撑感，肩胛骨也有承托，拒绝上背部落空，带来座驾级推背感'
							},
						],
						active: 'beikao',

					},
					{
						banner: this.GLOBAL.imgHost + '/images/sales/banner33.jpg',
						svgName:'',
						imgurl: [{
								img: this.GLOBAL.imgHost + '/images/sales/zhediezuodian1.jpg'
							},
							{
								img: this.GLOBAL.imgHost + '/images/sales/zhediezuodian2.jpg'
							},
							{
								img: this.GLOBAL.imgHost + '/images/sales/zhediezuodian3.jpg'
							},
						],
						write: [{
								title: '磁吸折叠便携，一拎即走，一秒开开合',
								letter: '不受场域限制，室内独处、户外旅修、公园放松、午休冥想、静心阅读皆适用；磁吸扣一靠即合，轻松收纳和提拎'
							},
							{
								title: '人体工学分区承托，更快进入冥想状态',
								letter: '贴合人体身形，让臀腿受力均匀、不易酸麻，稳定坐姿。①海底轮承托：提升专注力，快速进入冥想状态。②尾椎支撑：前低后高，承托尾椎保护脊椎。③臀部包裹：分散压力，防止臀部变形。④腿部支撑：可移动磁吸脚托，按需调整。'
							},
							{
								title: '比瑜伽垫更减压，比蒲团垫更柔弹',
								letter: '采用高回弹海绵，不同于普通棉垫，最大优势在于能够主动分散身体压力点，让肌肉放松、身体沉静；久坐不易塌陷变形，带来持久稳定的柔弹坐感'
							},
						],
						active: 'zhediezuodian',

					},
					{
						banner: this.GLOBAL.imgHost + '/images/sales/banner44.jpg',
						svgName:'',
						imgurl: [{
								img: this.GLOBAL.imgHost + '/images/sales/zuodian11.jpg'
							},
							{
								img: this.GLOBAL.imgHost + '/images/sales/zuodian22.jpg'
							},
							{
								img: this.GLOBAL.imgHost + '/images/sales/zuodian33.jpg'
							},
						],
						write: [{
								title: '人体工学分区承托，盘坐更轻松',
								letter: '前挡稳固足部、后顶托起尾椎、两侧包裹臀腿，久坐臀腿不易酸麻，有效延长冥想时间。①尾椎抬高，帮助脊柱自然挺立。②腿部创新凹槽设计，双膝平衡。③两侧加高包裹支撑，让身体更稳定。'
							},
							{
								title: '抗菌透气，久坐不烦闷',
								letter: '抗菌面料清新护持，透气亲肤，长时间静坐不易闷热，冥想久坐安心舒适'
							},
							{
								title: '高回弹海绵，持久支撑不塌陷',
								letter: '韧性强、弹性好、抗挤压：带来持久稳定支撑，舒适坐感，冥想更专注'
							},
						],
						active: 'zuodian1',

					},
				]
			}
		},
		components: {
			HNB,
			bottom,
			SvgIcon
		},
		mounted() {
			this.play()
		},
		methods: {
			autoplay() {
				this.num++
				if (this.num == 3) {
					this.num = 0
				}
			},
			play() {
				setInterval(this.autoplay, 5000)
			},
			choose(e) {
				// console.log("e", e)
				let that = this
				that.bottomactive = e
			},
			openherf(url) {
				let routeUrl = this.$router.resolve({
					path: "/Productstation",
					query: {
						globalname: url
					}
				});
				window.open(routeUrl.href, '_blank');
				// console.log("url", url)
			}
		}
	}
</script>

<style>
	@import url("../common/animate.min.css");

	.bannerinfo {
		width: 100%;
		height: 100%;
		/* line-height: 100%; */
		position: absolute;
		top: 0%;
		margin: 0 auto;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		
	}

	.bannerinfo .infobox1 {
		font-size: 2rem;
		font-family: 'Alibaba-PuHuiTi-M';
		font-weight: 500;
		color: rgba(255, 255, 255, 1);
		letter-spacing: 3px;

	}

	.bannerinfo .infobox2 {
		font-size: 1rem;
		 
		font-weight: 400;
		color: rgba(255, 255, 255, 1);
		letter-spacing: 3px;
		padding-top: 1%;
	}

	.bannerinfo .infobox3 {
		font-size: 0.9rem;
		 
		font-weight: 400;
		color: rgba(255, 255, 255, 1);
		cursor: pointer;
		padding-top: 3%;
	}

	.sales {
		/* width: 64rem; */
		margin: 0 auto;
	}

	.bannershell {
		width: 100%;
		height: 100%;
		position: absolute;
		background: rgba(0, 0, 0, 1);
		opacity: 0.6;
		top: 0%;
	}

	.sales .sales-banner {
		width: 100%;
		font-size: 0;
		position: relative;
	}

	.sales .sales-banner img {
		width: 100%;
	}

	.sales .sales-center {
		width: 100%;
		display: flex;
	}

	.sales .sales-center .left {
		width: 50%;
		background: rgba(244, 244, 244, 1);
	}

	.sales .sales-center .left .left-box1 {
		width: 100%;
		font-size: 18px;
		font-family: Alibaba-PuHuiTi-M;
		font-weight: 550;
		color: rgba(29, 29, 29, 1);
		line-height: 30px;
		text-align: left;
		padding-left: 20%;
		padding-right: 20%;
		padding-top: 17%;
		animation-duration: 2s;
	}

	.sales .sales-center .left .left-box2 {
		font-size: 0.85rem;
		height: 3.75rem;
		 
		font-weight: 400;
		color: rgba(29, 29, 29, 1);
		text-align: left;
		padding-left: 20%;
		padding-right: 20%;
		padding-top: 1rem;
		animation-duration: 2s;
	}

	.sales .sales-center .left .left-box3 {
		width: 0.5rem;
		height: 0.5rem;
		border-radius: 50%;
		background: rgba(215, 215, 215, 1);
		margin-left: 2%;
	}

	.sales .sales-center .left .left-box3.active {
		background: rgba(0, 199, 133, 1) !important;
		border: 0.0625rem !important;
	}

	.sales .sales-center .right {
		width: 50%;
	}

	.sales .sales-center .right img {
		width: 100%;
		height: 100%;
		animation-duration: 3s;
	}

	.sales .sales-bottom {
		display: flex;
		width: 90%;
		margin: 0 auto;
		margin-top: 3.125rem;
		margin-bottom: 7rem;
		align-items: center;
		justify-content: center;
	}

	.sales .sales-bottom .sales-shell {
		width: 190px;
		height: 190px;
		background: rgba(244, 244, 244, 1);
		margin-left: 0.5%;
		margin-right: 0.5%;
		/* padding-bottom: 1.5rem; */
		cursor: pointer;
	}

	.sales .sales-bottom .sales-shell.active {

		background: rgba(255, 255, 255, 1);
		box-shadow: 0px 1rem 1rem 0px rgba(41, 44, 51, 0.1) !important;
		border: 0.0625rem !important;
	}

	.sales .sales-bottom .sales-shell-top {
		width: 3rem;
		height: 0.9375rem;
		background: rgba(0, 199, 133, 1);
		border-radius: 1.125rem;
		color: white;
		font-weight: 550;
		font-size: 10px;
		margin-top: 0.625rem;
		margin-left: 0.625rem;
		padding: 5px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.sales .sales-bottom .sales-shell-img {
		width: 40%;
		height: 40%;
		margin: 0 auto;
		position: relative;
		/* padding-top: 0.625rem; */
	}

	.sales .sales-bottom .sales-shell-img img {
		width: 100%;
	}

	.sales .sales-bottom .sales-bottom-title {

		font-size: 0.9rem;
		font-family: Alibaba-PuHuiTi-M;
		font-weight: 550;
		color: rgba(29, 29, 29, 1);
		line-height: 30px;
		padding-top: 1.1rem;
	}

	.sales .sales-bottom .sales-bottom-write {
		font-size: 0.7rem;
		 
		font-weight: 400;
		color: rgba(29, 29, 29, 1);
	}
</style>
